import React, { useEffect, useRef, useState } from "react";
import UAE from "../../assets/images/UAE flag.jpeg";
import { FaLocationDot } from "react-icons/fa6";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import Image from "../../components/Image";
import { User } from "lucide-react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useUser } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
// Fix default marker icon not appearing in many setups
const orangeMarkerIcon = new L.DivIcon({
  className: "", // Remove default styling
  html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="48" viewBox="0 0 32 48">
      <path fill="#FF6237" d="M16 0C7.163 0 0 7.163 0 16c0 12 16 32 16 32s16-20 16-32C32 7.163 24.837 0 16 0zm0 24a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/>
    </svg>
  `,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});
const Profile = () => {
  const [locationName, setLocationName] = useState("Abu Dhabi, UAE");
  // const [profileData, setProfileData] = useState(null);
  const hasFetchedProfile = useRef(false);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  // useEffect(() => {
  //   fetchProfile();
  // }, [refresh]);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const handleEditShow = () => setShowEditModal(true);
  const handleEditClose = () => setShowEditModal(false);
  const [formData, setFormData] = useState({
    company_name: "",
    about: "",
    email: "",
    location: "",
    website: "",
    phone: "",
    secondary_phone: "",
    license_no: "",
    reg_year: "",
    check_validation: "true",
    social_accounts: {
      instagram: "",
      tiktok: "",
      twitter: "",
    },
    trade_license_no: "",
    trn: "",
  });
  const { userType, profileData, fetchProfile, updateProfile } = useUser();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  useEffect(() => {
    if (profileData && userType === "company") {
      setLocationName(profileData.location || "Abu Dhabi, UAE");
      setFormData({
        company_name: profileData.company_name || "",
        about: profileData.about || "",
        email: profileData.email || "",
        location: profileData.location || "",
        website: profileData.website || "",
        phone: profileData.phone || "",
        secondary_phone: profileData.secondary_phone || "",
        license_no: profileData.license_no || "",
        reg_year: profileData.reg_year || "",
        check_validation: "true",
        social_accounts: {
          instagram: profileData.social_accounts?.instagram || "",
          tiktok: profileData.social_accounts?.tiktok || "",
          twitter: profileData.social_accounts?.twitter || "",
        },
        trade_license_no: profileData.trade_license_no || "",
        trn: profileData.trn || "",
      });
    }
  }, [profileData]);

  // useEffect(() => {
  //   if (hasFetchedProfile.current) return;
  //   hasFetchedProfile.current = true;
  //   fetchProfile();
  // }, []);

  // const fetchProfile = async () => {
  //   try {
  //       const response = await ApiService.request({
  //         method: "GET",
  //         url: `/company/getProfile`,
  //       });
  //     const data = response.data;
  //     if (data.status) {
  //       const company = data.data.company;

  //       setProfileData(company);
  // setLocationName(company.location || "Abu Dhabi, UAE");

  // setFormData({
  //   company_name: company.company_name || "",
  //   about: company.about || "",
  //   email: company.email || "",
  //   location: company.location || "",
  //   website: company.website || "",
  //   phone: company.phone || "",
  //   secondary_phone: company.secondary_phone || "",
  //   license_no: company.license_no || "",
  //   reg_year: company.reg_year || "",
  //   check_validation: "true",
  //   social_accounts: {
  //     instagram: company.social_accounts?.instagram || "",
  //     tiktok: company.social_accounts?.tiktok || "",
  //     twitter: company.social_accounts?.twitter || "",
  //   },
  //   trade_license_no: company.trade_license_no || "",
  //   trn: company.trn || "",
  // });
  //     } else {
  //       toast.error(data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching profile:", error);
  //   }
  // };

  const LocationMarker = ({ setLocationName }) => {
    const [position, setPosition] = useState([24.4539, 54.3773]);

    useMapEvents({
      click(e) {
        setPosition([e.latlng.lat, e.latlng.lng]);
        fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${e.latlng.lat}&lon=${e.latlng.lng}`,
        )
          .then((res) => res.json())
          .then((data) => {
            setLocationName(data.display_name || "Unknown location");
          });
      },
    });

    return <Marker position={position} icon={orangeMarkerIcon} />;
  };

  if (!profileData) {
    return (
      <div
        className="inter-font d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <h4>Loading...</h4>
      </div>
    );
  }

  // const aboutText =
  //   profileData?.about +
  //   "Vel quasi provident Vel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi providentVel quasi provident" ||
  //   "No About Data.";
  // const displayText =
  //   aboutText.length > 150 ? `${aboutText?.substring(0, 150)}...` : aboutText;
  const aboutText = profileData?.about?.trim() || "No About Data.";

  // ✅ Truncate only if longer than 150 characters
  const displayText =
    aboutText.length > 150 ? `${aboutText.substring(0, 150)}...` : aboutText;

  const handleUpdateProfile = async () => {
    const form = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (typeof value === "object") {
        Object.entries(value).forEach(([subKey, subVal]) => {
          form.append(`${key}[${subKey}]`, subVal);
        });
      } else {
        form.append(key, value);
      }
    });
    if (logoFile) form.append("logo", logoFile);

    // Use context updateProfile function
    const result = await updateProfile(form);
    setIsEditing(false);
  };

  return (
    <div className="inter-font py-4 px-3" style={{ minHeight: "100vh" }}>
      <div
        className="inter-font mx-auto bg-white rounded-4 shadow p-4"
        style={{ width: "100%" }}
      >
        {!isEditing ? (
          <div className="inter-font row align-items-start">
            {/* Profile Image */}
            <div className="inter-font col-12 col-md-2 text-center mb-3 mb-md-0">
              <Image
                src={profileData?.logo}
                alt="Profile"
                style={{
                  width: "117px",
                  cursor: "pointer",
                  height: "117px",
                  border: "1px solid #d3d3d3",
                }}
                className="inter-font rounded-circle ms-2"
              />
            </div>

            {/* Profile Info */}
            <div className="inter-font col-12 col-md-10">
              <h2 className="inter-font inter-font">
                {profileData?.company_name}
              </h2>
              <p className="inter-font inter-font text-muted d-flex align-items-center flex-wrap">
                <FaLocationDot
                  className={`inter-font text-dark ${isRTL ? "ms-2" : "me-2"}`}
                />
                {profileData?.location}
                <img
                  src={UAE}
                  className={`inter-font rounded-1 ${isRTL ? "me-2" : "ms-2"}`}
                  style={{ width: "30px", height: "20px" }}
                  alt="UAE"
                />
              </p>

              <p
                className="inter-font inter-font text-muted"
                style={{ fontSize: "15px" }}
              >
                {displayText}
                {aboutText?.length > 150 && (
                  <span
                    className="text-danger inter-font"
                    style={{ cursor: "pointer" }}
                    onClick={handleShow}
                  >
                    {" "}
                    Read More
                    {/* {t("new_text_24")} */}
                  </span>
                )}
                {/* <span className="inter-font text-danger"> Read More...</span> */}
              </p>

              {/* Modal for full about section */}
              <Modal
                show={showModal}
                onHide={handleClose}
                centered
                size="lg"
                dir={isRTL ? "rtl" : "ltr"}
              >
                <Modal.Header
                  closeButton
                  style={{
                    direction: isRTL ? "rtl" : "ltr",
                  }}
                >
                  <Modal.Title
                    className="inter-font"
                    style={{
                      textAlign: isRTL ? "right" : "left",
                      width: "100%",
                    }}
                  >
                    {t("new_text_27")}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ direction: isRTL ? "rtl" : "ltr" }}>
                  <p
                    className="inter-font"
                    style={{
                      fontSize: "14px",
                      color: "#595959",
                      textAlign: isRTL ? "right" : "left",
                    }}
                  >
                    {aboutText}
                  </p>

                  <div className="row mt-4">
                    <div className="col-md-6 mb-3">
                      <strong
                        className="inter-font"
                        style={{
                          fontSize: "16px",
                          textAlign: isRTL ? "right" : "left",
                          display: "block",
                        }}
                      >
                        {t("c_ff_text30")}
                      </strong>
                      <p
                        className="inter-font"
                        style={{
                          fontSize: "14px",
                          color: "#939393",
                          textAlign: isRTL ? "right" : "left",
                        }}
                      >
                        {profileData?.email}
                      </p>
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong
                        className="inter-font"
                        style={{
                          fontSize: "16px",
                          textAlign: isRTL ? "right" : "left",
                          display: "block",
                        }}
                      >
                        {t("h_text5")}
                      </strong>
                      <p
                        className="inter-font"
                        style={{
                          fontSize: "14px",
                          color: "#939393",
                          textAlign: isRTL ? "right" : "left",
                        }}
                      >
                        {profileData?.phone}
                        {profileData?.secondary_phone && (
                          <>
                            <span className="inter-font mx-2">|</span>
                            {profileData?.secondary_phone}
                          </>
                        )}
                      </p>
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong
                        className="inter-font"
                        style={{
                          fontSize: "16px",
                          textAlign: isRTL ? "right" : "left",
                          display: "block",
                        }}
                      >
                        {t("new_text_25")}
                      </strong>
                      <p
                        className="inter-font"
                        style={{
                          fontSize: "14px",
                          color: "#939393",
                          textAlign: isRTL ? "right" : "left",
                        }}
                      >
                        {profileData?.category_id?.title}
                      </p>
                    </div>

                    <div className="col-md-6 mb-3">
                      <strong
                        className="inter-font"
                        style={{
                          fontSize: "16px",
                          textAlign: isRTL ? "right" : "left",
                          display: "block",
                        }}
                      >
                        {t("c_ff_text26")}
                      </strong>
                      <p
                        className="inter-font"
                        style={{
                          fontSize: "14px",
                          color: "#939393",
                          textAlign: isRTL ? "right" : "left",
                        }}
                      >
                        {profileData?.sector}
                      </p>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer style={{ direction: isRTL ? "rtl" : "ltr" }}>
                  <Button
                    style={{
                      backgroundColor: "#e15d4f",
                      color: "#fff",
                      border: "none",
                    }}
                    onClick={handleClose}
                  >
                    {t("c_t_close")}
                  </Button>
                </Modal.Footer>
              </Modal>

              <div className="inter-font row">
                {/* Left Column */}
                <div className="inter-font col-12 col-md-6 mb-4">
                  <h6 style={{ color: "#595959" }}>{t("c_ff_text30")}</h6>
                  <p style={{ color: "#939393" }}>{profileData?.email}</p>

                  <h6 style={{ color: "#595959" }} className="inter-font mt-3">
                    {t("new_text_26")}
                  </h6>
                  <p style={{ color: "#939393" }}>{locationName}</p>

                  <MapContainer
                    center={[24.4539, 54.3773]}
                    zoom={10}
                    attributionControl={false}
                    style={{
                      height: "200px",
                      width: "100%",
                      borderRadius: "10px",
                    }}
                  >
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <LocationMarker setLocationName={setLocationName} />
                  </MapContainer>

                  <p className="inter-font mt-2 text-center">{locationName}</p>

                  <button
                    className="inter-font btn btn-base inter-font w-100 mt-3"
                    onClick={() => setIsEditing(true)}
                  >
                    {t("c_profile_btn")}
                  </button>
                </div>

                {/* Right Column */}
                <div className="inter-font col-12 col-md-6">
                  <h6 style={{ color: "#595959" }}>{t("h_text5")}</h6>
                  <p style={{ color: "#939393" }}>
                    {profileData?.phone}
                    {profileData?.secondary_phone && (
                      <>
                        <span className="inter-font mx-2">|</span>
                        {profileData?.secondary_phone}
                      </>
                    )}
                  </p>

                  <h6 className="inter-font mt-3" style={{ color: "#595959" }}>
                    {t("new_text_25")}
                  </h6>
                  <p style={{ color: "#939393" }}>
                    {profileData?.category_id?.title}
                  </p>

                  <h6 style={{ color: "#595959" }} className="inter-font mt-3">
                    {t("c_ff_text26")}
                  </h6>
                  <p style={{ color: "#939393" }}>{profileData?.sector}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="inter-font p-5 ">
            <h4 className="mb-4">{t("new_text_28")}</h4>

            <div className="row g-4">
              {/* Profile Logo */}
              <div className="col-12 col-md-3 text-center">
                <div className="position-relative d-inline-block">
                  <Image
                    src={logoPreview || profileData?.logo}
                    alt="Profile"
                    style={{
                      width: "117px",
                      cursor: "pointer",
                      objectFit: "cover",
                      height: "117px",
                      border: "1px solid #d3d3d3",
                    }}
                    className="rounded-circle"
                  />

                  <label
                    htmlFor="logoUpload"
                    className="btn btn-sm btn-dark position-absolute rounded-circle d-flex align-items-center justify-content-center shadow"
                    style={{
                      cursor: "pointer",
                      bottom: "6px", // closer vertically
                      right: "1px", // closer horizontally
                      width: "28px",
                      height: "28px",

                      padding: 0,
                    }}
                  >
                    <i className="bi bi-camera"></i>
                  </label>

                  <input
                    type="file"
                    id="logoUpload"
                    accept="image/*"
                    style={{ display: "none" }}
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        setLogoFile(file);
                        const reader = new FileReader();
                        reader.onloadend = () => {
                          setLogoPreview(reader.result);
                        };
                        reader.readAsDataURL(file);
                      }
                    }}
                  />
                </div>
              </div>

              {/* Basic Info */}
              <div className="col-12 col-md-9">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">{t("h_text7")}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.company_name}
                      disabled
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          company_name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">{t("h_text4")}</label>
                    <input
                      type="email"
                      className="form-control"
                      value={formData.email}
                      disabled
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">{t("h_text5")}</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("c_ff_text54")}
                      value={formData.phone}
                      disabled
                      onChange={(e) =>
                        setFormData({ ...formData, phone: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">{t("new_text_40")}</label>
                    <input
                      type="text"
                      className="form-control"
                      // placeholder={t("c_ff_text54")}
                      value={formData.secondary_phone}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          secondary_phone: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">{t("new_text_27")}</label>
                    <textarea
                      className="form-control"
                      placeholder={t("new_text_38")}
                      rows="3"
                      value={formData.about}
                      onChange={(e) =>
                        setFormData({ ...formData, about: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Business Info */}
            <div className="row g-3 mt-4">
              <div className="col-md-6">
                <label className="form-label">{t("c_ff_text45")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("c_ff_text46")}
                  value={formData.website}
                  onChange={(e) =>
                    setFormData({ ...formData, website: e.target.value })
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t("c_ff_text32")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("c_ff_text33")}
                  value={formData.location}
                  onChange={(e) =>
                    setFormData({ ...formData, location: e.target.value })
                  }
                  disabled
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t("new_text_36")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("new_text_37")}
                  value={formData.license_no}
                  onChange={(e) =>
                    setFormData({ ...formData, license_no: e.target.value })
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t("new_text_34")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("new_text_35")}
                  value={formData.reg_year}
                  onChange={(e) =>
                    setFormData({ ...formData, reg_year: e.target.value })
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t("new_text_32")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("new_text_33")}
                  value={formData.trade_license_no}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      trade_license_no: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">{t("c_ff_text57")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("c_ff_text58")}
                  value={formData.trn}
                  onChange={(e) =>
                    setFormData({ ...formData, trn: e.target.value })
                  }
                />
              </div>
            </div>

            {/* Social Accounts */}
            <div className="row g-3 mt-4">
              <h5 className="mb-2">{t("new_text_31")}</h5>
              <div className="col-md-4">
                <label className="form-label">{t("c_ff_text51")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("c_ff_text52")}
                  value={formData.social_accounts?.instagram || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      social_accounts: {
                        ...formData.social_accounts,
                        instagram: e.target.value,
                      },
                    })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">{t("c_ff_text55")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("c_ff_text56")}
                  value={formData.social_accounts?.tiktok || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      social_accounts: {
                        ...formData.social_accounts,
                        tiktok: e.target.value,
                      },
                    })
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">{t("c_ff_text53")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("c_ff_text54")}
                  value={formData.social_accounts?.twitter || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      social_accounts: {
                        ...formData.social_accounts,
                        twitter: e.target.value,
                      },
                    })
                  }
                />
              </div>
            </div>

            {/* Save/Cancel */}
            {/* Save/Cancel */}
            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                className="btn "
                style={{
                  background: "#fff",
                  border: "1px solid #ccc",
                  color: "#595959",
                  borderRadius: "8px",
                  padding: "8px 24px",
                }}
                onClick={() => setIsEditing(false)}
              >
                {t("new_text_30")}
              </button>
              <button
                className="btn btn-base"
                style={{
                  background: "#e15d4f",
                  color: "#fff",
                  border: "none",
                  // borderRadius: "8px",
                  padding: "8px 24px",
                }}
                onClick={handleUpdateProfile}
              >
                {t("new_text_29")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
